import { render, staticRenderFns } from "./addToCart.vue?vue&type=template&id=72ebc49d"
import script from "./addToCart.vue?vue&type=script&lang=js"
export * from "./addToCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementBuilder: require('/home/ubuntu/containers/hermes_eshop/components/core/elementBuilder.vue').default})
